<template>
  <div
    ref="containerClass"
    :class="containerClass"
    v-if="!shouldRemoveAds()"
  >
    <nossr>
      <div
        v-if="adPos && (!isRestricted)"
        :id="adId"
        :class="[
          classProps,
          config.border ? '' : 'noborder',
          config.label ? '' : 'nolabel',
        ]"
        :data-pos="adPos"
        :data-sizes="JSON.stringify(adSizes)"
        :data-targets="JSON.stringify(adTargets)"
        :data-block-codes="blockCodes ? blockCodes : undefined"
        :data-is-mobile="JSON.stringify(isMobile)"
        :data-scp="scpKeys ? scpKeys : undefined"
      />
    </nossr>
  </div>
</template>
<script>
import useStore from '@/useStore.js';



import ads from 'webmd-ads-consumer'
import {ua} from 'webmd-useragent'
import debug from 'webmd-debug'
 import nossr from './client-only';
import _pick from 'lodash/pick';
import postmessageListener from 'webmd-postmessage-listener';
require("webmd-tug-eval-promise");

export default {
  name: 'WebmdAd',
  components:{
    nossr
  },
  props: {
    pos: {
      type: String,
      default: ''
    },
    chronicId: {
      type: String,
      default: ''
    },
    id: {
      default: '',
      type: String
    },
    sizes: {
      type: Array,
      default: () => []
    },
    keys: {
      default: '',
      type: String
    },
    targets: {
      type: String,
      default: '{}'
    },
    refresh: {
      type: Boolean,
      default: true
    },
    collapseAfter: {
      type: Boolean,
      default: false
    },
    collapseBefore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // making this reactive because we will update it before the mount hook
      adIndex: 1,
      ads_ignore: {},
      isMobile: false,
      breakPoint: "smallDesktop",
      restrictedPos: {
        "largeDesktop": [],
        "smallDesktop": [],
        "tablet": ['113'],
        // phablet is Mobile landscape
        "phablet": ['5000', '5001', '5002', '5003', '137'],
        "mobile": ['5000', '5001', '5002', '5003', '137']
      },
      config: {
        border: true,
        label: true,
      },
      pageLevelTargets: {},
      apiSizes:[],
    }
  },
  computed: {
    adTargets() {
      var targets_from_store;
      var all_targets;
      var json_formatted_targets;

      // make sure provided targets is in valid json string format
      json_formatted_targets = this.targets.replace(/'/g,'"');

      // grab the targets from cms store - if any
      targets_from_store = this.store?.pagedata?.ad?.targets || {};

      // merge user provided targets with targets from cms store
      all_targets = Object.assign(JSON.parse(json_formatted_targets), targets_from_store, this.pageLevelTargets);

      return all_targets;
    },
    blockCodes() {
      return this.store?.pagedata?.ad?.blockCodes || ''
    },
    adPos() {
		var pos = this.pos || this.getCmsPos;
		//check for ads ignore object if it contains the pos,
      //if yes we should not convert the pos and need to return it.
      if(this.ads_ignore[pos] == true) {
         return pos;
      }
      if (!pos) {
        console.error("pos or chronicle Id is required");
        return pos;
      }
      
      let pageName = this.store?.pagedata?.omniture?.s_pagename || '';
      let isCare = ((pageName.indexOf('doctor.webmd.com') > -1 || pageName.indexOf('doctor.staging.webmd.com') > -1));
      let isVitals = ((pageName.indexOf('vitals.com') > -1 || pageName.indexOf('staging.vitals.com') > -1));

      // suppress 121 - 2026 for Mobile pages on WebMD, not Vitals or Care pages 
      if (pos == '121' && this.isMobile && !(isCare||isVitals)) {
        debug("suppress 121 - 2026 for Mobile pages");
        pos = '';
        return pos;
      }

		if (this.isMobile) {
			switch (pos) {
				case '101':
				case '106':
					pos = '2025';
					break;
				case '102':
					pos = '2051';
					break;
				case '108':
					pos = '2108';
					break;
				case '109':
					pos = '2109';
					break;
				case '111':
					pos = '1111';
					break;
				case '108':
					pos = '2108';
					break;
				case '114':
				case '121':
				case '141':
					pos = '2026';
					break;
				case '901':
				case '902':
					pos = '1901';
					break;
				case '404':
					pos = '409';
					break;
				case '903':
					pos = '1903';
					break;
				case '922':
					pos = '1922';
					break;
				case '920':
					pos = '1920';
					break;
				case '921': // sharethrough pos
					pos = '1921';
					break;
				case '923':
					pos = '1923';
					break;
				case '926':
					pos = '1926';
					break;
				case '138':
					pos = '1380';
					break;
				case '5004':
					pos = '5054';
					break;
				case '113':
					// no left ad on mobile
					pos = '';
					break;
				default: // do nothing
			}
		} else {
			switch (pos) {
				case '106':
					pos = '101';
					break;
				case '404':
					pos = '409';
					break;
				default: // do nothing
			}
		}

		return pos;
    },
    adId: function() {
      return this.id || ('ad-pos-' + this.adPos ) + '-' + this.adIndex;
    },
    adSizes: function() {
      // On mobile device, if the sizes for desktop pos is passed in props, we are overriding it to default.
      if (this.isMobile && (this.pos != this.adPos)) {
        return this.apiSizes.length>0 ? this.apiSizes: [];
      }
      return this.apiSizes.length>0 ? this.apiSizes : this.sizes;
    },
    scpKeys: function() {
      return this.keys.replace(/'/g,'"');
    },
    classProps: function() {
      return 'module ad ad-' + this.adPos
    },
    containerClass: function() {
      return 'ad-wrapper ad-container-' + this.adPos;
    },
    getCmsPos: function() {
      let pos = '';

      if (!this.chronicId) {
        return pos;
      }

      let module = this.store.cms.getModules(this.chronicId);

      if (module) {
        let adUnit = module.module_data && module.module_data.AdUnit ? module.module_data.AdUnit: '';

        if (adUnit) {
          switch (adUnit) {
            case 'Top 728x90 (Top Ad Label)':
              pos = '101';
              break;
            case 'Top 728x90 (Side Ad Label)':
              pos = '102';
              break;
            case 'Banner Takeover 970x90':
              pos = '105';
              break;
            case 'Left Rail 120x600/160x600':
              pos = '113';
              break;
            case 'Right Rail 300x250':
              pos = '121';
              break;
            case 'Right Rail 300x600':
              pos = '131';
              break;
            case '1x1 Pixel':
              pos = '901';
              break;
            case '1x6 Pixel':
              pos = '920';
              break;
            case '1x4 Pixel':
              pos = '903';
              break;
            case 'Bottom Left Center Well 300x250':
              pos = '404';
              break;
            case 'Sponsor Box Center Well 1 (top)':
              pos = '5000';
              break;
            case 'Sponsor Box Center Well 2 (bottom)':
              pos = '5001';
              break;
            case 'Sponsor Box Right Rail 1 (top)':
              pos = '5002';
              break;
            case 'Sponsor Box Right Rail 2 (bottom)':
              pos = '5003';
              break;
            case 'Boots Promo Unit 300x198':
              pos = '700';
              break;
            case 'Boots Service Unit 145x199':
              pos = '701';
              break;
            case 'Mobile Top Banner 320x50/300x50':
              pos = '2025';
              break;
            case 'Mobile Bottom Banner 320x50/300x50':
              pos = '2026';
              break;
            case 'Mobile iFrame Top 320x50/300x50':
              pos = '2050';
              break;
            case 'Mobile iFrame Bottom 320x50/300x50':
              pos = '2051';
              break;
            case 'Right Rail Bottom 300x250':
              pos = '137';
              break;
            case 'Mobile 1x1':
              pos = '1901';
              break;
            case 'Mobile 1x6':
              pos = '1920';
              break;
            case 'Mobile 1x4':
              pos = '1903';
              break;
            case 'Above Footer (1x8)':
              pos = '922';
              break;
            case 'Above Footer Mobile (1x8)':
              pos = '1922';
              break;
            case 'Big block Unit':
              pos = '109';
              break;
            case 'Mobile Big block Unit':
              pos = '2109';
              break;
            case 'Marquee Unit':
              pos = '108';
              break;
            case 'Mobile Marquee Unit':
              pos = '2108';
              break;
            case 'Instream Unit':
              pos = '923';
              break;
            case 'Mobile Instream Unit':
              pos = '1923';
              break;
            case 'Instream 728x90':
              pos = '141';
              break;
            case '3x4 Pixel':
              pos='138';
              break;
            case 'Mobile 3x4 Pixel':
              pos = '1380';
              break;
            case '2x6 Pixel':
              pos = '926';
              break;
            case 'Mobile 2x6 Pixel':
              pos = '1926';
              break;
            default:
              pos = '';
          }
        }
      }

      return pos;
    },
    isRestricted: function() {
      /**
       * restrict rendering of the ad div if
       * 1. the pos is restricted on current breakPoint
       * 2. the pos is available in the ads_ignore object
       * 3. all ads are ignored in the ads_ignore object
       *
       */
      return ((this.restrictedPos[this.breakPoint].indexOf(this.adPos) > -1) || (this.ads_ignore[this.adPos]  == true) || (this.ads_ignore["all"] == true));
    }
  },
  created() {
       this.store = useStore(this.$pinia);
  	if (typeof window === 'undefined') { // executes only server side
		try {
			let module = this.store.cms.getModules(this.chronicId); //get the data from the store
			module = _pick(module, ['module_data.AdUnit']); //pick the data that is being used in this component and discard everything else
			this.store.cms.UPDATE_STATE({key: this.chronicId, value: module}) //set this new reduced data back to store
		} catch (err) {
			console.log(
				JSON.stringify({
					category: 'DATA_PICK',
					component: this.name,
					message: `Unable to optimize ${this.name} data object size in webmd-cms-store`,
					props: this.$props,
					stackTrace: err.stack,
					route: this.$route.fullPath,
				})
			);
		}
	}
  },
  
  beforeMount: function() {
    // we need to set the useragent here before the component mounts
    // otherwise the computed pos values will be incorrect
    this.isMobile = ua.type === 'mobile';
 
    //grabbing the global ads_ignore object and assigning it to local variable
    //we are ignoring the ads based on the values in ads_ignore object
    if(window && window.ads_ignore) {
      this.ads_ignore = window.ads_ignore;
    }
    
    //set breakpoint
    this.breakPoint = this.getBreakpoint();

    /**
    * need to display 113 on vitals, in tablet mode
    */
    if (window.location.hostname.indexOf('vitals.com') > -1 && this.breakPoint === 'tablet') {
    this.restrictedPos.tablet.splice(this.restrictedPos.tablet.indexOf('113'), 1);
    }
 
    /*Assigning a global variable for sequential ad Id's*/
    if (window && window.adIndex == undefined) {
      window.adIndex = {};
    }
    if(!this.id && this.adPos && !this.isRestricted) {
      if(window.adIndex[this.adPos]) {
        window.adIndex[this.adPos]++;
        this.adIndex = window.adIndex[this.adPos];
      }
      else {
        window.adIndex[this.adPos] = 1;
        this.adIndex = 1;
      }
    }
  },

  mounted: function() {
    // setting the Optimera by passing ad div Id and pos
    if (window.top === window.self && webmd.optimera) {
      webmd.optimera.setOptimera( this.adPos, this.adId);
    }

    // add postmessage listener to the page
    if(!window.postMessageListenerInitialized) {
      postmessageListener.init(this);
      window.postMessageListenerInitialized = true;
    }

    let adParams;
    let slotCreate;

    // we don't want to define an ad without a pos value
    if (!this.adPos) {
      return;
    }

    // return if all ads are ignored from the global ads_ignore object
    if(this.ads_ignore["all"] == true) {
      debug("All ad POS values are ignored");
      return;
    }

    // ads are not generated for restricted pos values in mobile
    if( this.isRestricted || (this.ads_ignore[this.adPos] == true)) {
      debug(`${this.adPos} is restricted!`);
      return;
    }

    /**
     *  if the page is using webmd-cms-store, the api call to admin tool is done on webmd-cms-store
     *  and the data is available on the store.
     *  if the store data from admin tool is not available, make api call from client side ( future implementation )
     *  this.store.ads object will be available on store data only
     *  if the admin tool api call is made from store.
     */
    if (this.store.ads) {
        // update pos level configurations from the admin tool api
        var posConfig = this.store.ads.adPosConfig || {};
        this.posConfigUpdate(posConfig);

        // set custom page level targets from admin tool api
        var pageLevelTargets = this.store.ads.adTargets || {};
        this.pageLevelTargets = Object.assign({}, pageLevelTargets);
    }

    debug("pagedata: " + this.store.pagedata);

    adParams = {
      id: this.adId,
      targets: this.adTargets,
      sizes:this.adSizes,
      blockCodes: this.blockCodes,
      pos: this.adPos,
      refresh: this.refresh,
      collapseBefore: this.collapseBefore,
      collapseAfter: this.collapseAfter
    };

    if (this.scpKeys) {
      adParams.keys = JSON.parse(this.scpKeys);
    }

    // this promise will get resolved when the slot has been created
    slotCreate = new Promise(function(resolve, reject) {
       Promise.resolve(window.tugEvalPromise).then(function(message, sponsor){
        ads.defineAd(adParams);
        resolve(`created a slot with info: ${adParams.id}`);
        debug(adParams);
      });

    }).then(function(msg) {
      debug('webmd-vue-ad: ' + msg)
    });

    // push the promise into the promises queue so we can display it later.
    this.$vue.adsPromiseQueue.push(slotCreate);
	this.$refs.containerClass.classList.value = this.containerClass;
  },

  methods: {
	posConfigUpdate(posConfig) {
		if (posConfig && posConfig[this.adPos]) {
			// enable border and label configuration from store data fetched from admin tool
			this.config.border = posConfig[this.adPos].border;
			this.config.label = posConfig[this.adPos].label;

			// set custom page level targets from admin tool
			if (posConfig[this.adPos].slotLevelTargets) {
				var slotLevelTargets = (this.keys === '') ? {} : JSON.parse(this.scpKeys);
				this.keys = JSON.stringify(Object.assign({}, slotLevelTargets, posConfig[this.adPos].slotLevelTargets));
			}

      //set custom pos sizes from admin tool
      if(posConfig[this.adPos].sizes) {
        this.apiSizes = posConfig[this.adPos].sizes;
      }

		}
	},
  getBreakpoint() {
      /** @type {Record<string, string>} */
      const breakpoints = {
        mobile: '(max-width: 639px)',
        phablet: '(min-width: 640px) and (max-width: 767px)',
        tablet: '(min-width: 768px) and (max-width: 1023px)',
        smallDesktop: '(min-width: 1024px) and (max-width: 1239px)',
        largeDesktop: '(min-width: 1240px)',
      };
      /** @type {keyof typeof breakpoints} */
      let breakpoint = 'mobile';
      for (const [key, query] of Object.entries(breakpoints)) {
        if (window.matchMedia(query).matches) {
          breakpoint = key;
          break;
        }
      }
      debug(`device :${breakpoint}`);
      return breakpoint;
    },
    shouldRemoveAds() {
        if (typeof window !== 'undefined' && window.location) {
          return window.location.href.indexOf('conmktvid') > -1;
        }
        return false; // Return false if the checks fail
    },
  },
}
</script>
<style lang="scss">
  @import "./scss/ads.scss";
  .ad-container:empty {
      display: none; /* Hide empty ad containers */
  }
</style>
